<!-- DetailsRegulation.vue -->
<script setup lang="ts">
  import { INodeComplementLinkProps, IRegulationsProps } from '@/types'
  import { Typography } from '@components/index'

  const props = defineProps<IRegulationsProps>()
  const emit = defineEmits(['onOpenModal'])

  const handleLinkClick = (data: INodeComplementLinkProps) => {
    emit('onOpenModal', data)
  }
</script>

<template>
  <div class="col-12">
    <Typography variant="regulation-topic">{{ props.title }}</Typography>
    <div class="mb-3 pt-2 pb-3 d-flex flex-column align-items-start">
      <Typography
        v-for="(data, index) in props.external_nodes"
        :key="index"
        variant="regulation-link"
        class="mb-2"
        @click="handleLinkClick(data)"
      >
        {{ data.title }}
      </Typography>
    </div>
  </div>
</template>
